import 'css-chunksrc/client/scenes/projectVirtualResourceAddition/virtualResourceForm/styles.scss';export default {
  "virtualResourceForm": "_virtualResourceForm_m0kc7_1",
  "row": "_row_m0kc7_8",
  "group": "_group_m0kc7_19",
  "label": "_label_m0kc7_23",
  "input": "_input_m0kc7_29",
  "textArea": "_textArea_m0kc7_45"
};